define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../models/UserContext", "../../models/EmployeeRoleModel"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, UserContext, EmployeeRoleModel) {
    "use strict";
    var EmployeeRole = /** @class */ (function () {
        function EmployeeRole() {
            this.userCanEditEmployeeRole = ko.observable(UserContext.hasAccess("Admin,EmployeeRole.Edit,EmployeeRole.Delete"));
            this.userCanDeleteEmployeeRole = ko.observable(UserContext.hasAccess("Admin,EmployeeRole.Delete"));
            this.filterByAny = ko.observable("");
            this.editModel = ko.observable(new EmployeeRoleModel());
        }
        EmployeeRole.prototype.init = function () {
            var self = this;
            $("#page-title").text("Employee Roles");
            tools.ajaxGet({
                url: "/EmployeeRole/GetLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.employeeRoleLookupList = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                    self.initGrid(self.employeeRoleLookupList.GridStructures.EmployeeRoleStructure);
                    ko.applyBindings(self, document.getElementById("main-container"));
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        EmployeeRole.prototype.initGrid = function (gridStructure) {
            var self = this;
            var gridId = "tblEmployeeRoleKendo";
            var columns = gridStructure.columns;
            //add actions column
            var actions = {
                field: "",
                width: "100px",
                template: function (dataItem) {
                    var html = "";
                    if (self.userCanEditEmployeeRole()) {
                        html += '<a class="btn btn-sm btn-info btn-edit" href="#"><i class="fa fa-edit "></i></a>';
                    }
                    if (self.userCanDeleteEmployeeRole()) {
                        html += '&nbsp;<button class="btn btn-sm btn-danger btn-remove" href="#"><i class="fa fa-trash-o "></i></button>';
                    }
                    return html;
                }
            };
            columns.push(actions);
            self.employeeRoleTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/EmployeeRole/GetEmployeeRoles",
                            type: "POST",
                            data: function () {
                                var data = {};
                                if (self.filterByAny()) {
                                    data.filterText = self.filterByAny();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model,
                    }
                },
                gridOptions: {
                    toolbar: kendo.template($("#employee-role-toolbar-template").html()),
                    columns: columns
                },
                gridId: gridId,
                showPagerOnTop: false,
                enableExport: {
                    entityName: "EmployeeRole",
                    title: "Employee Roles",
                    enablePdf: false
                },
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                controller: self
            };
            self.employeeRoleTable.initGrid(gridOptions);
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.employeeRoleTable.getGridData().dataSource.read();
            });
            $("#" + gridId + " tbody").on("click", ".btn-edit", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.editEmployeeRole(data.Id);
                event.preventDefault();
            }).on("click", ".btn-remove", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.deleteEmployeeRoleConfirm(data.Id, data.Name);
                event.preventDefault();
            });
        };
        EmployeeRole.prototype.editEmployeeRole = function (id) {
            var self = this;
            var title = "Add New Employee Role";
            if (!isNaN(id)) {
                title = "Edit Employee Role";
            }
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    //validate form
                    if (!self.editModel().Name()) {
                        tools.error("Employee Role Name is a required field");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    self.saveEmployeeRole(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    if (!isNaN(id)) {
                        getModelCall = tools.ajaxGet({
                            url: "/EmployeeRole/GetEmployeeRoleById",
                            data: { id: id },
                            success: function (result) {
                                if (result.Success) {
                                    self.editModel(new EmployeeRoleModel(result.Data));
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editModel(new EmployeeRoleModel());
                    }
                    $.when(getModelCall).done(function (data) {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'employee-role-edit-template', data: editModel }\"></div>");
                        ko.applyBindings(self, modal);
                        //log.log(parentDropDown);
                    });
                }
            });
        };
        EmployeeRole.prototype.saveEmployeeRole = function (btn, modal) {
            var self = this;
            var data = tools.modelToFormData(self.editModel());
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/EmployeeRole/SaveEmployeeRole",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    self.employeeRoleTable.refresh();
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        EmployeeRole.prototype.deleteEmployeeRole = function (id) {
            var self = this;
            var data = {
                id: id
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/EmployeeRole/DeleteEmployeeRoleConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Employee Role deleted successfully");
                    self.employeeRoleTable.refresh();
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        EmployeeRole.prototype.deleteEmployeeRoleConfirm = function (id, name) {
            var self = this;
            tools.confirmModal({
                title: "Delete Employee Role",
                text: "Are you sure you want to delete employee role " + name + "?",
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.deleteEmployeeRole(id);
            });
        };
        return EmployeeRole;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/EmployeeRole/Index")) {
            log.log("Initialize Employee role list");
            $(function () {
                (new EmployeeRole()).init();
            });
        }
    }, 0);
    return EmployeeRole;
});
//# sourceMappingURL=employeeRole.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/employeeRole/employeeRole.js
// module id = 296
// module chunks = 2